import script from "./CameraEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CameraEditor.vue?vue&type=script&setup=true&lang=ts"

import "./CameraEditor.vue?vue&type=style&index=0&id=959f0562&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.27_typescript@5.9.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-959f0562"]])

export default __exports__